<div id="goBackButtonContainer" *ngIf="!isAdmin">
  <button mat-button mat-flat-button (click)="goBack()">
    <img src="assets/img/svg/arrow-back.svg" alt="" width="24px" />
  </button>
</div>
<app-user-detail *ngIf="(isAdmin && canUseTRM)" [userUuid]="userToBook" [didSearch]="didSearch"
  (navigateEvent)="goBack()"></app-user-detail>

<mat-horizontal-stepper class="flight-booking-stepper" linear [linear]="isLinear" #stepper (selectionChange)="onStepSelectionChange($event)" [ngClass]="'stepper-idx-' + currentStepIndex">
  <ng-template matStepperIcon="edit" let-index="index">
    {{ index + 1 }}
  </ng-template>
  <mat-step label="{{ 'flight.select-fare' | translate }}" *ngIf="optimusMultiFamily?.fares.length > 0" #first_step>
    <ng-container *ngIf="(stepper.selected == null || stepper.selected == first_step) && company && userFilters">
      <app-flight-fares-list (nextStep)="nextStepFromFares($event)" [multiFamily]="optimusMultiFamily"
        (openPolicy)="openPoliciesDialog($event)" [userFilters]="userFilters" [totalFlightDuration]="totalFlightDuration"
        [userFilters]="userFilters" [company]="company" [isEmployee]="isEmployee">
      </app-flight-fares-list>
    </ng-container>
  </mat-step>
  <mat-step label="{{ 'flight.details' | translate }}" #second_step>
    <ng-container *ngIf="stepper.selected == second_step">
      <ng-container *ngIf="fareSelected !== null; else elseBlock">
        <app-flight-step-detail
          (baggageSelectedEvent)="updateBaggagePrice($event)"
          (seatMapEvent)="getSeatMap($event)"
          (nextStep)="goNextStep($event)"
          (changeFare)="backStepFromFares($event)"
          [multiFamily]="optimusMultiFamily"
          [fareName]="fareName"
          [totalPrice]="totalPrice"
          [fareSelected]="fareSelected"
          [selectedFlights]="selectedFlights"
          [durations]="durations"
          [requestData]="requestData"
          [userFilters]="userFilters"
          [selectedUsers]="selectedUsers"
          [totalFlightDuration]="totalFlightDuration"
          [company]="company"
          [isEmployee]="isEmployee"
          [journeysAssociations]="journeysAssociations"
        >
        </app-flight-step-detail>
      </ng-container>

      <ng-template #elseBlock>
        <app-flight-step-detail
          (baggageSelectedEvent)="updateBaggagePrice($event)"
          (seatMapEvent)="getSeatMap($event)"
          (nextStep)="goNextStep($event)"
          [multiFamily]="optimusMultiFamily"
          [fareName]="fareName"
          [totalPrice]="totalPrice"
          [durations]="durations"
          [selectedFlights]="selectedFlights"
          [requestData]="requestData"
          [userFilters]="userFilters"
          [selectedUsers]="selectedUsers"
          [totalFlightDuration]="totalFlightDuration"
          [company]="company"
          [isEmployee]="isEmployee"
          [journeysAssociations]="journeysAssociations"
        >
        </app-flight-step-detail>
      </ng-template>
    </ng-container>
  </mat-step>

  <mat-step label="{{ 'flight.passengers-data' | translate }}" #third_step>
    <ng-container *ngIf="stepper.selected == third_step">
      <app-flight-step-travelerform
        [totalPrice]="totalPrice"
        [travelersAge]="travelersAge.length > 0 ? travelersAge : stateService.flightTravelers"
        [isUser]="isUser"
        [userUuid]="userUuid"
        [needDocApis]="needDocApis"
        [needAddress]="needAddress"
        [fareSelected]="fareSelected"
        [selectedFlights]="selectedFlights"
        [stepper]="stepper"
        [selectedUsers]="selectedUsers"
        [company]="company"
        [isEmployee]="isEmployee"
        [userFilters]="userFilters"
        [passengerBookingParams]="passengerBookingParams"
        [travelerFormToRestore]="travelerFormToRestore"
      ></app-flight-step-travelerform>
    </ng-container>
  </mat-step>
  
  <mat-step label="{{ 'flight.pucharse-confirmation' | translate }}">
    <div style="display: flex;">
      <div id="confirm-container">
        <div id="confirm-text-container">
          <h6>{{ "flight.result-flight.almost-there" | translate }}</h6>
          <form id="extraInfo" [formGroup]="extraInfoForm" *ngIf="extraInfoForm != null">
            <div class="input-row">
              <div>
                <p class="semi-bold" style="padding-right: 1rem;">
                  {{ "common.custom-code" | translate }}
                </p>
                <label class="border-radius-20" style="width: 100%; padding-right: 1rem;">
                  <input id="customCode" type="text" formControlName="customCode" placeholder="(PPT...)"
                    class="form-control form-control--no-border" />
                </label>
              </div>
              <div>
                <p class="semi-bold" style="padding-left: 1rem;">
                  {{ "common.cost-center" | translate }}
                </p>
                <label class="border-radius-20" style="width: 100%; padding-left: 1rem;">
                  <input id="costCenter" type="text" formControlName="costCenter"
                    class="form-control form-control--no-border" />
                </label>
              </div>
            </div>
            <div class="row">
              <div class="input-full-row" *ngIf="((userFilters.onlyFlightAuthorization || isOverDurationLimit) && !isAdmin)">
                <label class="border-radius-20">
                  <textarea id="travellerReason" formControlName="travellerReason"
                    placeholder="{{ 'authorization.comment-reason' | translate }}"
                    class="form-control form-control--no-border" rows="3"></textarea>
                </label>
              </div>
              <div class="input-full-row">
                <p class="semi-bold">
                  {{ "flight.form-flight.annotations" | translate }}
                </p>
                <label class="border-radius-20">
                  <textarea id="annotationsExtras" formControlName="annotationsExtras"
                    placeholder="{{ 'flight.form-flight.extras-annotations' | translate }}"
                    class="form-control form-control--no-border" rows="4"></textarea>
                </label>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="col-4" id="price-col">
        <div id="details-container">
          <span *ngIf="canUseResident" class="resident-applied">{{ 'flight.resident-applied' | translate }}</span>
          <div class="details-buy-text" [ngClass]="{ 'no-fare': fareSelected == null }">
            <ng-container *ngIf="fareSelected && farePricing; else elseBlock">
              <p>{{ "flight.flight-info" | translate}}</p>
              <div class="buy-text">
                <div>
                  <div *ngIf="userFilters.onlyFlightAuthorization || isOverDurationLimit"
                    style="display: flex; justify-content: center;">
                    <span class="admin-permission-msg">{{ "authorization.permissions-required" | translate }}</span>
                  </div>
                </div>
                <div *ngIf="fareSelected">
                  <div class="total-price base-price">
                    <p>{{ "hotel.base-rate" | translate }}:</p>
                    <p>
                      {{
                        (!company?.showCommissions || isEmployee)
                          ? farePricing.total
                          : farePricing.amount
                          | price
                          }} €
                        </p>
                      </div>
                      <div class="total-price fee-emit" *ngIf="company?.showCommissions || isEmployee">
                        <p>{{ "flight.result-flight.fee-emit" | translate }}:</p>
                        <p>{{ (farePricing.total - farePricing.amount) | price }} €</p>
                      </div>
                      <div class="total-price baggage-price" *ngIf="selectBaggage?.length > 0">
                        <p>{{ "my-bookeds.flight.baggage" | translate }} ({{ getBaggagesNumber() }}):</p>
                        <p>{{ getTotalBaggagePrice() | price }} €</p>
                      </div>
                      <div class="total-price priority-price" *ngIf="selectedPriority?.length > 0">
                        <p>{{ "flight.detail-flight.priority" | translate }}:</p>
                        <p>{{ getTotalPriorityPrice() | price }} €</p>
                      </div>
                      <div class="total-price baggage-price" *ngIf="selectedSeats">
                        <p>{{ "my-bookeds.train-flight.seat" | translate }}: </p>
                        <p>{{ expectedAmountSeats | price }} €</p>
                      </div>
                      <div class="total-price total-price-label">
                        <p>{{ "flight.result-flight.total-price" | translate }}:</p>
                        <p>{{ totalPrice | price }} €</p>
                      </div>
                    </div>
                    <span class="change-fare" (click)="goToFirstStep()">
                      {{ "flight.result-flight.change-fare" | translate }}
                    </span>
                  </div>
                
              <div *ngIf="accomInfo" style="margin-top: 1rem;">
                  <p>
                    {{ "hotel.accom-info" | translate }}
                  </p>
                <div>
                  <div *ngIf="accomInfo.needsAuth"
                    style="display: flex; justify-content: center;">
                    <span class="admin-permission-msg">{{ "authorization.permissions-required" | translate }}</span>
                  </div>
                  <div *ngFor="let room of accomInfo.selectedRooms; let j = index">
                    <p style="font-weight: 600;">{{ "hotel.room" | translate}} {{j + 1}}: {{room.name}}</p>
                    <div class="total-price base-price"
                      *ngIf="room.rates[0].price && accomInfo.hotel.code.charAt(0) !== 'E'">
                      <p>{{ "hotel.base-rate" | translate }}: </p>
                      <p>{{ room.rates[0].price.totalPrice.total | price }}€</p>
                    </div>
                    <div class="total-price base-price"
                      *ngIf="room.rates[0].price && accomInfo.hotel.code.charAt(0) !== 'E'">
                      <p *ngIf="room.rates[0].price.fees && room.rates[0].price.fees.amount > 0"
                        style="color: #f46f69" matTooltip="{{ 'hotel.due-at-property-details' |translate }}">{{
                        "hotel.due-at-property" | translate }} <i class="fa fa-question-circle"></i>: </p>
                      <p>{{room.rates[0].price.fees.amount | price }}€</p>
                    </div>
                    <div class="total-price base-price"
                      *ngIf="room.rates[0].price && accomInfo.hotel.code.charAt(0) === 'E'">
                      <p *ngIf="room.rates[0].price.baseRate && room.rates[0].price.baseRate.amount > 0">{{
                        "hotel.base-rate" | translate }}: </p>
                      <p>{{ room.rates[0].price.baseRate.amount | price }}€</p>
                    </div>
                    <div class="total-price base-price"
                      *ngIf="room.rates[0].price.taxAndServiceFee && room.rates[0].price.taxAndServiceFee.amount > 0">
                      <p matTooltip="{{ 'hotel.taxes-and-fees-details' |translate }}">{{ "hotel.taxes-and-fees" |
                        translate }} <i class="fa fa-question-circle"></i>: </p>
                      <p>{{ room.rates[0].price.taxAndServiceFee.amount | price }}€</p>
                    </div>
                    <div class="total-price base-price"
                      *ngIf="room.rates[0].price.salesTax && room.rates[0].price.salesTax.amount > 0">
                      <p>{{
                        "hotel.sales-tax" | translate }}: </p>
                      <p>{{ room.rates[0].price.salesTax.amount | price }}€</p>
                    </div>
                    <div class="total-price base-price"
                      *ngIf="room.rates[0].price.fees && room.rates[0].price.fees.amount > 0">
                      <p style="color: #f46f69" matTooltip="{{ 'hotel.due-at-property-details' |translate }}">{{
                        "hotel.due-at-property" | translate }} <i class="fa fa-question-circle"></i>: </p>
                      <p>{{ room.rates[0].price.fees.amount | price }}€</p>
                    </div>
                    <div class="total-price base-price"
                      *ngIf="room.rates[0].price && room.rates[0].price.totalPrice.total">
                      <p>{{ "search.search-booked.total-price-by-room" | translate }}: </p>
                      <p>{{ room.rates[0].price.totalPrice.total | price }}€</p>
                    </div>
                  </div>
                  <div class="total-price total-price-label">
                    <p>{{ "search.search-booked.total-price" | translate }}: </p>
                    <p>{{ getTotalPriceAccom() | price }}€</p>
                  </div>
                </div>
              </div>
            </ng-container>
            <div class="total-price total-price-label" *ngIf="accomInfo">
              <p style="font-size: medium; font-weight: 600;">{{ "hotel.total-price-package" | translate }}: </p>
              <p style="font-size: medium; font-weight: 600;">{{ getTotalPackage() | price }} €</p>
            </div>
            <ng-template #elseBlock>
              <ng-container>
                <p>{{ "flight.result-flight.total-price" | translate }}:</p>
                <p *ngIf="totalPrice > 0">{{ totalPrice | price }} €</p>
              </ng-container>
            </ng-template>
          </div>
          <div id="confirm-button-container">
            <div>
              <p style="font-size: 10px; font-weight: 300; margin-top: 15px; text-align: center;">
                {{ "common.policies.clic" | translate
                }}<a href="https://www.vyootrip.com/aviso-legal/" target="_blank">{{
                  "common.policies.terms-of-use" | translate
                  }}</a>{{ "common.policies.confirm" | translate
                }}<a href="https://www.vyootrip.com/politica-de-cookies/" target="_blank">{{
                  "common.policies.cookie-policy"
                  | translate }}</a>
              </p>
            </div>
            <h6>
              {{
              (((userFilters.onlyFlightAuthorization || isOverDurationLimit) && !isAdmin)
                ? "flight.result-flight.confirm-auth"
                : "flight.result-flight.confirm-book")
              | translate }}
            </h6>
            <div class="button-container">
              <button id="cancel" matStepperPrevious>
                {{ "flight.detail-flight.cancel" | translate }}
              </button>
              <button id="confirm" (click)="
                      ((userFilters.onlyFlightAuthorization || isOverDurationLimit) && !isAdmin)
                        ? requestFlight()
                        : confirmFlight()
                    ">
                {{ (isPackageRate && isPackageRate == 'flight' ? "hotel.package-go-accommodation" : "flight.detail-flight.confirm") | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </mat-step>

  <button #nextStep matStepperNext style="display: none">Next</button>
</mat-horizontal-stepper>